<template>
  <el-row class="card-main">
      <el-col>
        <el-col v-for="(item, index) in $store.state.princess" v-if="item.status == '正常'"
        :key="index"
          :lg="5"
          :md="7"
          :sm="12"
          :xs="12">
          <div class="card-top-title"><span>{{ item.desc }}</span></div>
          <div class="card-item">
            <div class="card-item-img">
              <img :src="getImageUrl(item.url)" height="246px" width="100%" :alt="item.title" @click="handleClickFun(index)">
              <div class="age">胸围 {{ item.cir }}</div>
              <div class="Nheight">身高 {{ item.stature }}</div>
            </div>
            <div class="card-item-info">
              <div @click="handleClickFun(index)">
                <span class="card-item-title">{{ item.title }}</span>
              </div>
              <span class="card-item-desc">{{ item.info }}</span>
              <div class="price-list" v-if="item.pricelist">
              <span v-for="(ptem, pi) in item.pricelist">
                {{ptem.price}}
              </span>
              </div>
            </div>
          </div>
        </el-col>

      </el-col>
      <el-col>
        <el-col v-for="(item, index) in $store.state.princess" v-if="item.status == '客评'"
                :key="index"
          :lg="5"
          :md="7"
          :sm="12"
          :xs="12">
          <div class="card-top-title"><span>{{ item.desc }}</span></div>
          <div class="card-item">
            <div class="card-item-img">
              <img :src="getImageUrl(item.url)" height="246px" width="100%" :alt="item.title" @click="handleClickFun(index)">
              <div class="age">胸围 {{ item.cir }}</div>
              <div class="Nheight">身高 {{ item.stature }}</div>
            </div>
            <div class="card-item-info">
              <div @click="handleClickFun(index)">
                <span class="card-item-title">{{ item.title }}</span>
              </div>
              <span class="card-item-desc">{{ item.info }}</span>
              <div class="price-list" v-if="item.pricelist">
              <span v-for="(ptem, pi) in item.pricelist">
                {{ptem.price}}
              </span>
              </div>
            </div>
          </div>
        </el-col>

      </el-col>
      <el-col>
        <el-col  v-for="(item, index) in $store.state.princess" v-if="item.status == '联系'"
                 :key="index"
          :lg="5"
          :md="7"
          :sm="12"
          :xs="12">
          <div class="card-top-title"><span>{{ item.desc }}</span></div>
          <div class="card-item">
            <div class="card-item-img">
              <img :src="getImageUrl(item.url)" height="246px" width="100%" :alt="item.title" @click="handleClickFun(index)">
              <div class="age">胸围 {{ item.cir }}</div>
              <div class="Nheight">身高 {{ item.stature }}</div>
            </div>
            <div class="card-item-info">
              <div @click="handleClickFun(index)">
                <span class="card-item-title">{{ item.title }}</span>
              </div>
              <span class="card-item-desc">{{ item.info }}</span>
              <div class="price-list" v-if="item.pricelist">
              <span v-for="(ptem, pi) in item.pricelist">
                {{ptem.price}}
              </span>
              </div>
            </div>
          </div>
        </el-col>

      </el-col>

  </el-row>
</template>

<script>
export default {
  data() {
    return {
      crrentIndex: 0
    };
  },
  mounted() { },
  methods: {
    handleClickFun(index) {
      let k = Number(index) + 1;
      let s = k.toString();
      this.crrentIndex = k;
      this.$router.push({ path: "/princess", query: { id: s } });
    },
    getImageUrl(url){
      // return require(`@/assets/ranking${url}`);
      return 'https://api2.seattletaotao.com'+url;
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .card-top-title{
    margin-top: 0.35rem; 
  }

}

@media only screen and (min-width: 768px) {
  .card-top-title{
    margin-top: 1.5rem; 
  }
}
/deep/ .el-divider{
  background-color: red;
}
/deep/ .el-divider__text{
  background-color: red;
  padding: 3px 20px;
  letter-spacing:6px;
  font-size: 18px;
  color: #fff;
}
.card-top-title{ 
  height: 50px;
  line-height: 50px;
  margin-left: 0.05rem;
  margin-right: 0.05rem;
  background-color: rgba(212,212,212,0.15);
  border-bottom: 2px solid #cfcfcf;
  overflow: hidden;
  white-space: nowrap;
}
.card-top-title span{
  font-size: 15px;
  color: white;
}

.card-item {
  padding: 0.25rem;
  margin-bottom: 16px;
  }
/deep/ .el-image__inner {
  height: 211px !important;
}
.carditem-item{
  position: relative;
}
.card-main {
  margin: auto;
  position: relative;
  color: white;
}
.card-item-info{
  background-color: rgba(212,212,212,0.15);
  padding-top: 8px;
  padding-bottom: 8px;
}
.card-item-img{
  position: relative;
}

.card-item img,
.card-item-title {
  cursor: pointer;
}

.Nheight,
.age {
  position: absolute;
  padding: 2px 6px;
  background-color: rgba(212,212,212,0.65);
  border-radius: 8px;
  opacity: 0.8;
  color: white;
  font-size: 13px;
}
.Nheight {
  top: 40px;
  left: 3px;
}
.age {
  top: 10px;
  left: 3px;
  background-color: rgba(212,212,212,0.15);
}
.card-item-title {
  color: white;
  font-weight: bold;
  font-size: 1.3rem;
  overflow: hidden;
  white-space: nowrap;
}
.card-item-time {
  height: 2rem;
  line-height: 2rem;
  color: #f787c9;
  font-weight: bold;
}
.card-item-desc {
  text-align: left;
  /*text-indent: 1.5rem;*/
  font-size: 13px;
  padding: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  line-height: 1.5rem;
  -webkit-box-orient: vertical;
}
.hide {
  display: none;
}
.price-list {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}
.price-list span {
  margin: 5px 15px;
  padding: 3px 0px;
  border-radius: 6px;
  /*background-color: #f787c9;*/
  background-color: #121212;
  color: white;
}

.textTitle{
  color: rgb(247, 135, 201);
}

</style>



// WEBPACK FOOTER //
// src/components/cardsView.vue